
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host(.hidden) {
  display: none;
}

:host {
  display: inline-block;
}
:host li {
  list-style: none;
}

:host(:first-child) a {
  margin-left: 0;
}

:host {
  color: var(--slh-color-outline, #4C49D4);
}
:host a {
  display: flex;
  justify-content: center;
  align-items: center;
  color: inherit;
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  line-height: var(--slh-base-xxs-line-height, 24px);
  font-size: var(--slh-base-xxs-font-size, 12px);
  text-decoration: none;
  font-family: var(--slh-default-font-family, "Open Sans");
  padding: 0 4px;
  position: relative;
}
:host a:focus {
  outline: none;
}
:host a:focus-visible {
  outline: none;
}
:host a:focus-visible::after {
  content: "";
  display: block;
  width: calc(100% - 4px);
  height: 100%;
  position: absolute;
  top: -2px;
  left: 0;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 4px;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  outline: none;
}
.breadcrumb-item .separator {
  margin: 0 4px 0;
  font-family: var(--slh-default-font-family, "Open Sans");
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  font-size: var(--slh-base-xs-font-size, 14px);
  line-height: var(--slh-base-xxs-line-height, 24px);
}
.breadcrumb-item.last .separator {
  display: none;
}
`;
